import { render, staticRenderFns } from "./SystemMessageModal.vue?vue&type=template&id=55ec5256&"
import script from "./SystemMessageModal.vue?vue&type=script&lang=js&"
export * from "./SystemMessageModal.vue?vue&type=script&lang=js&"
import style0 from "./SystemMessageModal.vue?vue&type=style&index=0&id=55ec5256&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports